import { redirect } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { BoundedApiError } from '@bounded/api-client';
import { q } from '../api/queries';

/**
 * Route guard. 401 → sign in. 403 → signed in on this origin but not an admin (or the account is
 * disabled): shown as a dead end, never as an empty admin shell.
 */
export async function requireAdmin(queryClient: QueryClient, href: string) {
  try { return await queryClient.ensureQueryData(q.me()); }
  catch (error) {
    if (error instanceof BoundedApiError && error.status === 401) throw redirect({ to: '/sign-in', search: { next: href } });
    if (error instanceof BoundedApiError && error.status === 403) throw redirect({ to: '/forbidden' });
    throw error;
  }
}
/** Only same-origin paths; anything else (//evil, https://…) falls back to home. */
export const safeNext = (value: unknown) => typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\') ? value : undefined;
